import type { TieredBillingPlan } from 'common/api/endpoints/companies';

export default function getPriceTier(plan: TieredBillingPlan, trackedUserCount: number) {
  const priceTier = plan.priceTiers.find((priceTier) => {
    return trackedUserCount <= priceTier.users;
  });
  return priceTier || plan.priceTiers[plan.priceTiers.length - 1];
}
